<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="书币福利" color="#ffffff"></navBar>
    <div class="content">
      <img src="../../../static/give-bg.jpg" alt="" />
      <div class="content-pos">
        <p class="content-title">微信VIP读者福利</p>
        <img class="icon-text" src="../../../static/give2.png" alt="">
        <div class="content-box" :class="receiveStatus?'content-default':''">
          <p><span>{{ currency }}</span>书币福利 </p>
          <p @click="sendCurrency">{{receiveStatus?'已领取成功':'立即领取'}}</p>
        </div>
        <p class="tips-currency">您的书币余额：{{userCurrency}} 书币</p>
        <div class="right-look" @click="goBook">
            马上去看书 <img src="../../../static/give1.png" alt="" />
          </div>
        <div class="text-tips">
<p>每月福利各种赠币活动，敬请持续关注；</p>
<p>赠币有效期均为{{validiTime}}天，请及时使用。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      isEntranceData: "",
      pageType: "",
      currency: 0,
      receiveStatus: true, //领取状态，true领取，false未领取
      validiTime: 0, //有效时间
      userCurrency:'',
      promotionCode:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.promotionCode) {
      this.promotionCode = this.$route.query.promotionCode;
    }
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
      this.getJumpUrlBookCurrency();
  
    } else {
      this.insertPageAccessData();
      this.getJumpUrlBookCurrency();
    }
  },
  methods: {
    insertPageAccessData() {
      // this.pageType
      var  pagename='';
      if(this.pageType=='bookCity'){
        pagename='书城'
      }else if(this.pageType=='bookCharge'){
        pagename='充值中心'
      }
      var params = {
        pageName: "微信VIP读者福利",
        pageRemark: "上级页面：" + pagename,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    goBook() {
      this.$base.setStorage("tabbarIndex", 0);
      this.$router.replace({ path: "/" });
    },
    sendCurrency(){//领取书币接口
      if(this.receiveStatus){
        return false;
      }
      var params={
        promotionCode:this.promotionCode
      }
      this.$api.receiveJumpUrlBookCurrency(params).then((res) => {
        if (res.status == 1) {
          Toast({
            message: '领取成功',
          });
          this.getJumpUrlBookCurrency();
        }
      });
    },
    getJumpUrlBookCurrency() { //获取书币接口
      var params={
        promotionCode:this.promotionCode,
        automaticCollection:2
      }
      this.$api.getJumpUrlBookCurrency(params).then((res) => {
        if (res.status == 1) {
          this.currency = res.data.currency;
          this.receiveStatus = res.data.receiveStatus;
          this.validiTime = res.data.effectTime;
          this.userCurrency = res.data.remainingBookCurrency;
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  min-height: 100%;
  background-color: #f3f3f3;
  overflow: hidden;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.content {
  width: 100%;
  margin-top: calc(44px + env(safe-area-inset-top));
  box-sizing: border-box;
  position: relative;
}
.content > img {
  width: 100%;
  display: block;
}
.content-pos {
  position: absolute;
  top: 0px;
  left: 0px;
  padding:30px 16px;
  width: 100%;
  box-sizing: border-box;
}
.content-title {
  font-size: 14px;
  color: #F92140;
  line-height: 27px;
  text-align: center;
  margin: 0 auto;
  width: 147px;
height: 27px;
background-image: linear-gradient(180deg, #FFEBAE 0%, #FFB94C 99%);
border-radius: 100px;
}
.icon-text{
  width: 264px;
height: 48px;
display: block;
margin:30px auto;
margin-bottom:70px;
}

.content-box {
  width: 305px;
  height: 90px;
  margin:0px auto;
  box-sizing: border-box;
  text-align: center;
  background-image: url('../../../static/give3.png');
  background-size: 100%;
  overflow: hidden;
}
.content-default{
  background-image: url('../../../static/give4.png');
  background-size: 100%;
}
.content-box > p:nth-of-type(1) {
  font-size: 20px;
color: #FFECC6;
margin-top: 14px;
line-height: 28px;
margin-bottom:5px;
}
.content-default > p:nth-of-type(1){
  color: #5C5C5C;
}
.content-box > p:nth-of-type(2){
  width: 98px;
height: 27px;
background-image: linear-gradient(180deg, #FCE9A6 0%, #F5B04E 100%);
border-radius: 4px;
font-size: 14px;
color: #E92C00;
text-align: center;
font-weight: 500;
line-height: 27px;
margin:0 auto;
} 
.content-default > p:nth-of-type(2){
  background: #C6C6C6;
border-radius: 4px;
color: #4E4E4E;
}
.content-box > div {
  background-image: linear-gradient(-180deg, #ffedae 0%, #ffd28b 100%);
  border-radius: 100px;
  font-size: 18px;
  color: #842a00;
  width: 280px;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;
  margin-bottom: 14px;
  font-weight: bold;
}
.content-box > div img {
  width: 17px;
  height: 10px;
}

.text-tips {
  font-size: 12px;
  color: #d5cdb6;
  width: 305px;
height: 74px;
background: #FFECC4;
border-radius: 6px;
font-size: 12px;
color: #885741;
font-weight: 500;
padding:20px;
box-sizing: border-box;
}

.tips-currency{

font-size: 14px;
color: #9A6E55;
font-weight: 500;
text-align: center;
margin-top: 20px;
}
.right-look{
  width: 170px;
height: 40px;
background-image: linear-gradient(180deg, #F1A64A 0%, #F92440 99%);
border-radius: 20px;
margin:30px auto;
font-size: 18px;
color: #FDE29D;
text-align: center;
line-height: 40px;
}
.right-look>img{
  width: 22px;
height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/giveCurrency/index.vue